<template>
  <v-app>
    <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="fab"
        fab
        dark
        fixed
        bottom
        right
        color="primary"
        @click="toTop"
        title="Back To Top"
      >
        <v-icon small>fas fa-chevron-up fa-2x</v-icon>
      </v-btn>
    </v-fab-transition>
    <!-- <live-chat></live-chat> put back in when available -->
    <navigation></navigation>
    <cookie-banner></cookie-banner>
    <v-main class="main-wrapper">
      <router-view></router-view>
    </v-main>
    <Footer></Footer>
  </v-app>
</template>

<script>
import Footer from '@/components/Footer.vue';
import Navigation from '@/components/navbars/Navigation.vue';
import CookieBanner from '@/components/CookieBanner.vue';

export default {
  name: "BusinessWebsiteApp",
  components: {
    Footer,
    Navigation,
    CookieBanner
  },
  data() {
    return {
      fab: false,
    };
  },
  methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.fab = top > 2000;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
};
</script>

<style>
#app {
  font-family: 'Roboto', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--v-backdrop-base);
}
</style>
